import { UserDataAction } from './actions'
import { UserGrid } from './types'

export interface State {
  guiUserData: UserGrid
  apiUserData: UserGrid
}

export const initialState: State = {
  guiUserData: { data: null, pending: false, error: false },
  apiUserData: { data: null, pending: false, error: false }
}

export default (state = initialState, action: UserDataAction): State => {
  switch (action.type) {
    case 'userData.fetchData':
      return {
        ...state,
        [action.payload.gridName]: {
          data: null,
          pending: true,
          error: false
        }
      }
    case 'userData.addData':
      const { gridName, data } = action.payload
      return {
        ...state,
        [gridName]: {
          data,
          pending: false,
          error: false
        }
      }
    case 'userData.fetchFail':
      return {
        ...state,
        [action.payload.gridName]: {
          data: null,
          pending: false,
          error: true
        }
      }

    default:
      return state
  }
}
